<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.125 5.84961C6.53908 5.84961 6.87479 6.18558 6.875 6.59961V12.2002C6.87489 12.6143 6.53915 12.9502 6.125 12.9502C5.71085 12.9502 5.37511 12.6143 5.375 12.2002V6.59961C5.37521 6.18558 5.71092 5.84961 6.125 5.84961Z" fill="white"/>
    <path d="M8.875 5.84961C9.28908 5.84961 9.62479 6.18558 9.625 6.59961V12.2002C9.62489 12.6143 9.28915 12.9502 8.875 12.9502C8.46085 12.9502 8.12511 12.6143 8.125 12.2002V6.59961C8.12521 6.18558 8.46092 5.84961 8.875 5.84961Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 0.25C9.21091 0.25 10.7334 1.41796 10.9678 3.0498H13C13.4141 3.0498 13.7499 3.38568 13.75 3.7998C13.75 4.19527 13.4438 4.51835 13.0557 4.54688L12.9883 12.2314C12.9713 14.167 11.4216 15.75 9.48828 15.75H5.4375C3.49189 15.75 1.9376 14.1479 1.9375 12.2002V4.5459C1.55259 4.51408 1.25 4.19293 1.25 3.7998C1.25011 3.38568 1.58585 3.0498 2 3.0498H4.03223C4.26663 1.41796 5.78909 0.25 7.5 0.25ZM3.4375 12.2002C3.4376 13.3451 4.34568 14.25 5.4375 14.25H9.48828C10.5732 14.25 11.4781 13.3562 11.4883 12.2188L11.5557 4.5498H3.4375V12.2002ZM7.5 1.75C6.52005 1.75 5.78769 2.33829 5.56934 3.0498H9.43066C9.21231 2.33829 8.47995 1.75 7.5 1.75Z" fill="white"/>
    </svg>
</template>

<script>

export default {
  name: 'trashСanIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
